import type { CommonRoom } from './commonRooms.hooks'

export const getEquipmentList = (space: CommonRoom) => {
  if (space.equipment === null) {
    return []
  }

  try {
    const equipmentKeys = Object.keys(space.equipment) as Array<keyof typeof space.equipment>

    return equipmentKeys.reduce((list, key) => {
      const value = space.equipment[key]
      if (Array.isArray(value)) {
        return [...list, ...value]
      } else if (typeof value === 'string') {
        return [...list, value]
      }
      return list
    }, [] as string[])
  } catch (error) {
    return []
  }
}
